<div class="documentation-icon-button">
    <mat-icon (click)="enableEdit()" [matTooltip]="documentation.comment || (placeholderTranslationKey | translate)">
        information
    </mat-icon>

    @if (isEditing) {
        <textarea
            [(ngModel)]="documentation.comment"
            (blur)="submitComment()"
            (keyup.enter)="submitComment()"
            placeholder="Enter text"
            class="edit-input">
        </textarea>
    }
</div>